import { FC, useContext, useState } from "react";

import Button from "../../../../components/Button";
import { CheckIcon, CrossIcon, EditV2Icon } from "../../../../assets/img/icons";
import { AuthContext } from "../../../../contexts/AuthContext";
import Input from "../../../../components/Input";
import { toast } from "react-toastify";
import { updateUser } from "../../../../services/api/user";

import styles from "./styles.module.scss";
import { useMediaQuery } from "@mui/material";
import {
    REQUIRED_FIELD,
    FieldErrors,
    clearFieldError,
    notifyFieldErrors,
    setFieldErrors,
} from "../../../../utils/errors";

const Infos: FC = () => {
    const [editMode, setEditMode] = useState(false);
    const { user, refreshAccessToken } = useContext(AuthContext)!;

    const [firstname, setFirstname] = useState(user?.firstname || "");
    const [lastname, setLastname] = useState(user?.lastname || "");
    const [email, setEmail] = useState(user?.email || "");
    const [fieldErrors, setFieldErrorsState] = useState<FieldErrors>({});

    const isMobile = useMediaQuery("(max-width: 1050px)");

    const handleSave = async () => {
        const nextErrors = setFieldErrors(
            ["firstname", !firstname.trim() && REQUIRED_FIELD],
            ["lastname", !lastname.trim() && REQUIRED_FIELD],
            ["email", !email.trim() && REQUIRED_FIELD]
        );
        setFieldErrorsState(nextErrors);
        if (
            notifyFieldErrors(nextErrors, {
                message: "Tous les champs sont requis.",
                type: "error",
            })
        ) {
            return;
        }

        try {
            await updateUser({
                firstname,
                lastname,
                email,
            });

            await refreshAccessToken();

            setEditMode(false);
            toast.success("Vos informations ont été mises à jour.");
        } catch (error) {
            toast.error("Une erreur est survenue lors de la mise à jour.");
        }
    };

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <span className={styles.title}>Informations personnelles</span>
                {editMode ? (
                    <div className={styles.buttons_container}>
                        <Button
                            onClick={() => setEditMode(false)}
                            variant="outlined"
                            className={styles.edit_button}
                            Icon={isMobile ? CrossIcon : undefined }
                            label={isMobile ? "" : "Annuler"}
                            size="small"
                        />
                        <Button
                            onClick={() => handleSave()}
                            variant="outlined"
                            className={styles.edit_button}
                            Icon={isMobile ? CheckIcon : undefined }
                            label={isMobile ? "" : "Sauvegarder"}
                            size="small"
                        />
                    </div>
                ) : (
                    <Button
                        onClick={() => setEditMode(true)}
                        variant="outlined"
                        LeftIcon={EditV2Icon}
                        className={styles.edit_button}
                        label={isMobile ? "" : "Editer informations"}
                        size="small"
                    />
                )}
            </div>
            <div className={styles.content}>
                <div className={styles.line}>
                    <div className={styles.item}>
                        <span className={styles.label}>Prénom</span>
                        {editMode ? (
                            <Input
                                type="text"
                                value={firstname}
                                onChanged={(value) => {
                                    setFirstname(value);
                                    setFieldErrorsState((prev) =>
                                        clearFieldError(prev, "firstname")
                                    );
                                }}
                                error={fieldErrors.firstname}
                            />
                        ) : (
                            <span className={styles.value}>
                                {user?.firstname || "-"}
                            </span>
                        )}
                    </div>
                    <div className={styles.item}>
                        <span className={styles.label}>Nom</span>
                        {editMode ? (
                            <Input
                                type="text"
                                value={lastname}
                                onChanged={(value) => {
                                    setLastname(value);
                                    setFieldErrorsState((prev) =>
                                        clearFieldError(prev, "lastname")
                                    );
                                }}
                                error={fieldErrors.lastname}
                            />
                        ) : (
                            <span className={styles.value}>
                                {user?.lastname || "-"}
                            </span>
                        )}
                    </div>
                </div>
                <div className={styles.line}>
                    <div className={styles.item}>
                        <span className={styles.label}>Adresse e-mail</span>
                        {editMode ? (
                            <Input
                                type="email"
                                value={email}
                                onChanged={(value) => {
                                    setEmail(value);
                                    setFieldErrorsState((prev) =>
                                        clearFieldError(prev, "email")
                                    );
                                }}
                                error={fieldErrors.email}
                            />
                        ) : (
                            <span className={styles.value}>
                                {user?.email || "-"}
                            </span>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Infos;
